module.exports = __webpack_public_path__ + "ab9b3fb92d3d58959aaa23af40626189.jpg";